<mat-card class="wrap">
  <mat-card-header>
    <mat-card-title>{{ title }}</mat-card-title>
    <ng-content select="[header-right]"></ng-content>
  </mat-card-header>
  <mat-card-content>
    <ng-content select="[main]"></ng-content>
    <mat-divider *ngIf="hasActionDivider"></mat-divider>
    <!-- action -->
    <div *ngIf="hasSubmit" [class]="actionCssClass">
      <button type="submit" mat-flat-button color="primary" class="m-2" (click)="onSubmit()"
        [disabled]="isDisabled || loading">
        <ng-container *ngIf="loading; else text">
          <mat-icon>
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
        </ng-container></button>
    </div>
    <div *ngIf="hasFooter" class="mt-2">
      <ng-content select="[footer]"></ng-content>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #text>
  {{ submitText }}
</ng-template>
